import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-countdown', 'days', 'Dienas');
Labels.set('ui-countdown', 'hours', 'Stundas');
Labels.set('ui-countdown', 'minutes', 'Minūtes');
Labels.set('ui-countdown', 'seconds', 'Sekundes');
